import React from 'react';
import styles from './Home.module.scss';
import Header from '../../components/Header/Header';
import MainBanner from '../../components/MainBanner/MainBanner';
import rightArrow from '../../assets/rightArrow.png';
import processImage01 from '../../assets/processImage01.png';
import processImage02 from '../../assets/processImage02.png';
import processImage03 from '../../assets/processImage03.png';
import star from '../../assets/star.png';
import doctor02 from '../../assets/doctors/doctor02.png';
import doctor04 from '../../assets/doctors/doctor04.png';
import doctor05 from '../../assets/doctors/doctor05.png';
import doctor06 from '../../assets/doctors/doctor06.png';
import doctor07 from '../../assets/doctors/doctor07.png';
import doctor08 from '../../assets/doctors/doctor08.png';
import country01 from '../../assets/country/country1.png';
import country02 from '../../assets/country/country2.png';
import country03 from '../../assets/country/country3.png';
import country04 from '../../assets/country/country4.png';
import youjiyou from '../../assets/doctors/youjiyou.png';
import kimmiri from '../../assets/doctors/kimmiri.png';
import banner02 from '../../assets/bannerImage02.png';
import america from '../../assets/america.png';
import MainReview from '../../components/MainReview/MainReview';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Footer from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { IProductListType } from '../ProductList/ProductList';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import MainFaqFrame from '../../components/MainFaqFrame/MainFaqFrame';
import process01 from '../../assets/process01.png';
import process02 from '../../assets/process02.png';
import process03 from '../../assets/process03.png';
import process04 from '../../assets/process04.png';
import subBanner from '../../assets/banner/subBanner.png';
import mainFaqData from '../../assets/data/mainFaq.json';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga';
import { setTrueInitialize } from '../../reducers/gaInitialize';
import { useTranslation } from 'react-i18next';
import LazyLoad from 'react-lazy-load';
import axios from 'axios';
import popup from '../../assets/popup/popup.png';
import Popup from '../../components/Popup/Popup';
import gambichaBanner from "../../assets/banner/gambichaBanner.png"
import biumwhanBanner from "../../assets/banner/biumhwanBanner.png"
import dietProgramBanner from "../../assets/banner/dietProgramBanner.png";
import aboutOndoc1 from "../../assets/banner/aboutOndoc1.png";
import aboutOndoc2 from "../../assets/banner/aboutOndoc2.png";
import aboutOndoc3 from "../../assets/banner/aboutOndoc3.png";

export interface IProductDetailType {
  // brand_id: null;
  // brand_name: null;
  // company_id: 'mozzi';
  // company_image: null;
  company_name: string;
  content: string;
  cp_delivery_freeprice: number;
  cp_delivery_price: number;
  cp_delivery_use: string;
  delivery_case_price: number;
  delivery_cost: number;
  delivery_description: string;
  delivery_price: number;
  delivery_type: string;
  is_prescription: number;
  delivery_price_info: {
    delivery_company: string;
    delivery_complain_fail: string;
    delivery_complain_ok: string;
    delivery_complain_price: string;
    delivery_date: string;
    delivery_return_addr: string;
  };
  detail_url: string;
  discount_price: number;
  discount_rate: number;
  hashtag: string;
  id: string;
  image: string;
  is_like: number;
  list_image: string;
  option_depth: number;
  p_shoppingPayFree: number;
  p_shoppingPayPdPrice: number;
  p_shoppingPayPfPrice: number;
  price: number;
  product_id: number;
  provision_notice: null;
  review_score_avg: {
    product_id: number;
    review_point_0_avg: number;
    review_point_1_avg: number;
    review_point_2_avg: number;
    review_point_3_avg: number;
    review_point_total_avg: number;
    review_total_count: number;
  };
  soldout: string;
  stock_count: number;
  title: string;
  is_sales_started: string;
  selling_end_at: string;
  selling_started_at: string;
}

const mainFaqList = mainFaqData;
const countryList = [country01, country02, country03, country04];
function Home() {
  const [detail, setDetail] = useState<IProductDetailType>();
  const navigate = useNavigate();
  const location = useLocation();
  //프로세스
  const [processSliderIdx, setProcessSliderIdx] = useState(0);
  //프로세스
  //상품
  const priorityOrder = [38, 11, 10];

  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      const sessionIds: number[] = JSON.parse(
        sessionStorage.getItem('product_ids') || JSON.stringify([]),
      );
      // always fetch the featured products so the ONDOC PRODUCT cards render on a fresh visit
      const ids = Array.from(new Set([...priorityOrder, ...sessionIds]));
      const queryString = `add_products=${ids.join(',')}`;
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
    {
      staleTime: 60000 * 60 * 24,
    },
  );
  //상품
  //faq
  // const { data: faqListQuery } = useQuery<{
  //   data: IFaqType[];
  //   faq_type: {
  //     [key: number]: string;
  //   };
  // }>('faq', () => axiosClient.get('/data/faq').then((res) => res.data.data), {
  //   staleTime: 60000 * 60 * 24, //1일 캐싱
  // });
  //faq

  //기존 상품 url접속시 대응
  const gaInitialize = useSelector((state: any) => state.gaInitialize);
  const dispatch = useDispatch();
  useEffect(() => {
    let pn = new URLSearchParams(location.search).get('pn');
    if (!pn) return;
    if (pn == 'product.view') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=N&code=${new URLSearchParams(
            location.search,
          ).get('pcode')}`,
        )
        .then((res) => {
          if (res.data.data.message) alert(res.data.data.message);
          navigate(res.data.data.url);
        });
    } else if (pn == 'blind_gate') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=Y&code=${new URLSearchParams(
            location.search,
          ).get('bc')}`,
        )
        .then((res) => {
          if (res.data.data.message) alert(res.data.data.message);
          navigate(res.data.data.url);
        });
    }
  }, [gaInitialize]);
  //기존 상품 url접속시 대응
  const [doctorSliderIdx, setDoctorSliderIdx] = useState(0);

  const { t, i18n } = useTranslation();
  
  function saleDateCheck() {
    if (detail?.is_sales_started == 'N') {
      alert(t('other.55'));
      return false;
    } else return true;
  }
  
  function handleBasket() {
    // 비로그인용 장바구니 코드 삽입 필요
    if (!saleDateCheck()) return;
    
    
  }

  const productsInfo = [
    {
      name: "Cheongdam Bogam Diet tablet",
      description: "Cheongdam Bogam to lose weight for \n a short period of time a quick diet program. \n A healthy diet in which you can succeed at once while taking \n care of your health.",
      url: dietProgramBanner,
    },
    {
      name: "Cheongdam Bogam Gambi Tea",
      description: "Seven carefully selected herbal ingredients \n by experts in Ondoc. Cleanse your daily life gently \n with nature’s finest ingredients.",
      url: gambichaBanner,
    },
    {
      name: "Cheongdam Bogam Bium Hwan",
      description: "A healthy twice-daily habit. \n Empower your everyday with natural vitality.",
      url: biumwhanBanner,
    }
  ];

  const prioritizedList = priorityOrder
    .map(pid => productList?.find(product => product.product_id === pid))
    .filter((product): product is IProductListType => !!product);

  return (
    <div className={styles.container}>
      <Header />
      <MainBanner />
      {/* <div className={styles.processWrap}>
        <h3>{t('home.1')}</h3>
        <p>{t('home.2')}</p>
        <ul className={styles.hashtag}>
          <li># {t('home.3')}</li>
          <li># {t('home.4')}</li>
          <li># {t('home.5')}</li>
        </ul>
        <div className={styles.processSliderWrap}>
          <Swiper
            slidesPerView={1}
            spaceBetween={0}
            className={styles.processSlider}
            onSlideChange={(e) => setProcessSliderIdx(e.activeIndex)}
          >
            <SwiperSlide className={styles.processSlide}>
              <img src={process01} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.6')}</h4>
                <p>{t('home.7')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process02} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.8')}</h4>
                <p>{t('home.9')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process03} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.10')}</h4>
                <p>{t('home.11')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process04} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.12')}</h4>
                <p>{t('home.13')}</p>
              </div>
            </SwiperSlide>
          </Swiper>
          <ul className={styles.processSliderPagination}>
            {(() => {
              let list = [0, 1, 2, 3];
              return list.map((val) => (
                <li
                  key={val}
                  className={processSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul>
        </div>
      </div> */}
      {/* <Popup /> */}
      {/*<div className={styles.worldPlatform}>*/}
      {/*  <h3 dangerouslySetInnerHTML={{ __html: t('home.59') }}></h3>*/}
      {/*  <ul>*/}
      {/*    {countryList.map((country, idx) => (*/}
      {/*      <li key={idx}>*/}
      {/*        <img src={country} />*/}
      {/*      </li>*/}
      {/*    ))}*/}
      {/*  </ul>*/}
      {/*  <p>{t('home.60')}</p>*/}
      {/*</div>*/}
      {/* <div className={styles.prescriptionProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=487`)}>
          <span>{t('home.14')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.15')}</span>
        <Swiper
          slidesPerView={2.3}
          spaceBetween={10}
          className={styles.prescriptionProductSlider}
        >
          {productList
            ?.filter((product) => product.is_prescription == 1)
            .map((product) => (
              <SwiperSlide
                key={product.product_id}
                className={styles.prescriptionProductSlide}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div className={styles.thumbnailWrap}>
                  <img src={product.list_image} alt="productThumbnail" />
                </div>
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag) => <li># {hashtag}</li>)}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div> */}
      {/* <div className={styles.normalProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=488`)}>
          <span>{t('home.16')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.17')}</span>
        <ul className={styles.normalProductList}>
          {productList
            ?.filter((product) => product.is_prescription == 0)
            .filter((product, idx) => idx == 0)
            .map((product) => (
              <li
                key={product.product_id}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div className={styles.productThumbnailWrap}>
                  <img src={product.list_image} alt="productThumbnail" />
                </div>
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag, idx) => <li key={idx}>{hashtag}</li>)}
                  </ul>
                </div>
              </li>
            ))}
        </ul>
      </div> */}
      <div className={styles.allProductList}>
        <h3>
          <span>ONDOC PRODUCT</span>
        </h3>
        {/* <span>{t('home.18')}</span> */}
        <ul className={styles.productListWrap}>
          {prioritizedList
            .map((product, idx) => (
              <li
                key={product.product_id}
                className={`${styles.productCard} ${idx % 2 === 1 ? styles.reverse : ''}`}
              >
                <div className={styles.clientImageWrap}>
                  <img src={productsInfo[idx].url} alt={`Product Image ${idx + 1}`} />
                </div>
                <div
                  className={`${styles.productInfoWrap} ${
                    idx % 2 === 1 ? styles.alignLeft : ''
                  }`}
                >
                  <div className={styles.thumbnail}>
                    <img
                      src={product.list_image + '?w=200'}
                      alt="Product Thumbnail"
                    />
                  </div>
                  <h3>{productsInfo[idx].name}</h3>
                  <p
                    className={`${styles.description} ${
                      idx % 2 === 1 ? styles.alignLeft : ''
                    }`}
                  >
                    {productsInfo[idx].description.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                  <span className={styles.price}>
                    ${product.discount_price.toLocaleString()}
                  </span>
                  <div className={styles.buttonGroup}>
                    {/* <button 
                      className={styles.addToCart}
                    >
                      Add to Cart
                    </button> */}
                    <button
                      className={styles.shopNow}
                      onClick={() => navigate(`/productDetail/${product.product_id}`)}
                    >
                      Shop Now
                    </button>
                  </div>
                </div>
              </li>
            ))}
        </ul>
        {productList && productList.length > 4 && (
          <button onClick={() => navigate(`/productList`)}>
            {t('home.19')}
          </button>
        )}
      </div>
      <div className={styles.aboutOndocWrap}>
        {/* <div className={styles.textSection}>
          <h2>Free Shipping on orders $70+</h2>
        </div> */}
        <Swiper
          slidesPerView={2}
          spaceBetween={20}
          centeredSlides={false}
          className={styles.aboutSwiper}
        >
          <SwiperSlide className={styles.imageCard}>
            <div className={styles.image} style={{ backgroundImage: `url(${aboutOndoc1})` }}></div>
            <div className={styles.textOverlay}>
              <h3>Carefully <br /> Processed</h3>
              <p>Advanced techniques preserve <br /> the full benefits of each herb.</p>
            </div>
          </SwiperSlide>
          <SwiperSlide className={styles.imageCard}>
            <div className={styles.image} style={{ backgroundImage: `url(${aboutOndoc2})` }}></div>
            <div className={styles.textOverlay}>
              <h3>Sourced <br /> from Nature</h3>
              <p>High-quality herbs, handpicked <br /> from nature’s finest sources.</p>
            </div>
          </SwiperSlide>
          <SwiperSlide className={styles.imageCard}>
            <div className={styles.image} style={{ backgroundImage: `url(${aboutOndoc3})` }}></div>
            <div className={styles.textOverlay}>
              <h3>Delivered <br /> Wellness</h3>
              <p>Convenient, ready-to-use products <br /> for a balanced, healthy life.</p>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className={styles.faqWrap}>
        <h3 onClick={() => navigate(`/faq`)}>
          <span>ONDOC FAQ</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.20')}</span>
        <ul>
          {mainFaqList?.map((faq, idx) => (
            <MainFaqFrame faq={faq} key={idx} />
          ))}
        </ul>
      </div>
      <LazyLoad>
        <MainReview />
      </LazyLoad>
      {/* <div className={styles.ondocInfo}>
        <div>
          <div>
            <h3>{t('home.22')}</h3>
            <p>{t('home.23')}</p>
          </div>

          <img src={processImage01} alt="image" />
        </div>
        <div>
          <div>
            <h3>{t('home.24')}</h3>
            <p>{t('home.25')}</p>
          </div>
          <img src={processImage02} alt="image" />
        </div>
        <div>
          <div>
            <h3>{t('home.26')}</h3>
            <p>{t('home.27')}</p>
          </div>
          <img src={processImage03} alt="image" />
        </div>
      </div> */}
      {/* <div>
        <img src={subBanner} alt="sub_banner" style={{ width: '100%' }} />
      </div> */}
      {/*<div className={styles.legitScript}>*/}
      {/*  <img src={america} alt="america" />*/}
      {/*  <div>*/}
      {/*    <div className={styles.legitLogoWrap}>*/}
      {/*      <img*/}
      {/*        src="	https://static.legitscript.com/seals/14145209.png"*/}
      {/*        alt="legit"*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    <p>{t('home.58')}</p>*/}
      {/*    <p>*/}
      {/*      Ondoc started with US legitScript*/}
      {/*      <br />*/}
      {/*      contactless medical certification has been obtained.*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className={styles.doctorInfoWrap}>
        <h3>ONDOC DOCTORS</h3>
        <p>{t('home.28')}</p>
        <div className={styles.doctorSliderWrap}>
          <Swiper
            slidesPerView={3}
            spaceBetween={10}
            className={styles.doctorSlider}
            onSlideChange={(e) => setDoctorSliderIdx(e.activeIndex)}
          >
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img src={doctor02} alt="doctor" />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.29')}</h4>
                  <span>Lee Soyoung</span>
                  <ul>
                    <li>{t('home.30')}</li>
                    <li>{t('home.31')}</li>
                    <li>{t('home.32')}</li>
                    <li>{t('home.33')}</li>
                    <li>{t('home.34')}</li>
                    <li>{t('home.35')}</li>
                    <li>{t('home.36')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={youjiyou}
                    alt="doctor"
                    style={{ maxWidth: '151px' }}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.37')}</h4>
                  <span>Yoo jiyou</span>
                  <ul>
                    <li>{t('home.38')}</li>
                    <li>{t('home.39')}</li>
                    <li>{t('home.40')}</li>
                    <li>{t('home.41')}</li>
                    <li>{t('home.42')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={kimmiri}
                    alt="doctor"
                    style={{
                      maxWidth: '183px',
                      objectPosition: 'top',
                    }}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.43')}</h4>
                  <span>Kim miri</span>
                  <ul>
                    <li>{t('home.44')}</li>
                    <li>{t('home.45')}</li>
                    <li>{t('home.46')}</li>
                    <li>{t('home.47')}</li>
                    <li>{t('home.48')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={doctor04}
                    alt="doctor"
                    className={styles.bigImage}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.37')}</h4>
                  <span>Kim Unjung</span>
                  <ul>
                    <li>{t('home.38')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={doctor05}
                    alt="doctor"
                    className={styles.bigImage}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.39')}</h4>
                  <span>Kim Jihyun</span>
                  <ul>
                    <li>{t('home.40')}</li>
                    <li>{t('home.41')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={doctor06}
                    alt="doctor"
                    className={styles.bigImage}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.42')}</h4>
                  <span>Park Eunyoung</span>
                  <ul>
                    <li>{t('home.43')}</li>
                    <li>{t('home.44')}</li>
                    <li>{t('home.45')}</li>
                    <li>{t('home.46')}</li>
                    <li>{t('home.47')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={doctor07}
                    alt="doctor"
                    className={styles.bigImage}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.48')}</h4>
                  <span>Jang Hyodoo</span>
                  <ul>
                    <li>{t('home.49')}</li>
                    <li>{t('home.50')}</li>
                    <li>{t('home.51')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.doctor}>
                <div className={styles.doctorImageWrap}>
                  <img
                    src={doctor08}
                    alt="doctor"
                    className={styles.bigImage}
                  />
                </div>
                <div className={styles.doctorInfo}>
                  <h4>{t('home.52')}</h4>
                  <span>Jeon Youkyung</span>
                  <ul>
                    <li>{t('home.53')}</li>
                    <li>{t('home.54')}</li>
                    <li>{t('home.55')}</li>
                  </ul>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>
          {/* <ul className={styles.doctorSliderPagination}>
            {(() => {
              let list = [0, 1, 2, 3, 4, 5, 6, 7];
              return list.map((val) => (
                <li
                  key={val}
                  className={doctorSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul> */}
        </div>
      </div>
      <div className={styles.ondocService}>
        <img src={banner02} alt="banner" />
        <div className={styles.textWrap}>
          <span> 
            Ondoc offers the finest <br />
            health supplements.
          </span>
          <p>
            Ondoc is a service that sells health supplements made with the optimal combination to help <br /> customers recover their health quickly, safely, conveniently, and easily, by listening to and <br /> collaborating with certified Korean traditional medicine doctors to address their concerns.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Home;
